import { ValidationResult } from '../types'
import i18n from 'i18next'

function validatePhoneNumber(
	phoneNumber: string | undefined,
): ValidationResult {
	if (phoneNumber == '' || phoneNumber == undefined) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	if (phoneNumber.length > 7 && !isNaN(parseInt(phoneNumber))) {
		return {
			success: true,
			output: phoneNumber,
		}
	} else {
		return {
			success: false,
			output: i18n.t(
				'consumerInputs-personalInformationValidation-validatePhoneNumberInvalid-text',
			),
		}
	}
}

export default validatePhoneNumber
